<template>
  <div class="loading-screen">

    <!-- Animated background rings -->
    <div class="bg-ring ring-1"></div>
    <div class="bg-ring ring-2"></div>
    <div class="bg-ring ring-3"></div>

    <div class="loading-card">
      <img src="../../../assets/dmpLogin.png" class="loading-logo" alt="DMP Logo" />

      <div v-if="user && user.name" class="welcome-text">
        Welcome, <span class="user-name">{{ user.name }}</span>
      </div>

      <!-- Progress bar -->
      <div class="progress-track">
        <div class="progress-bar"></div>
      </div>

      <div class="loading-label">
        <fa :icon="['fas', 'spinner']" class="fa-spin me-2" />
        Loading Map Management Platform...
      </div>
    </div>

  </div>
</template>

<style scoped>
.loading-screen {
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ffffff;
  overflow: hidden;
}

/* ── Animated background rings ───────────────── */
.bg-ring {
  position: absolute;
  border-radius: 50%;
  border: 1px solid rgba(74, 116, 168, 0.12);
  animation: pulse-ring 4s ease-out infinite;
}

.ring-1 {
  width: 360px;
  height: 360px;
  animation-delay: 0s;
}

.ring-2 {
  width: 560px;
  height: 560px;
  animation-delay: 1s;
}

.ring-3 {
  width: 760px;
  height: 760px;
  animation-delay: 2s;
}

@keyframes pulse-ring {
  0%   { transform: scale(0.85); opacity: 0.6; }
  100% { transform: scale(1.15); opacity: 0; }
}

/* ── Card ────────────────────────────────────── */
.loading-card {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.5rem;
  background: #fff;
  border: 1px solid rgba(74, 116, 168, 0.15);
  border-radius: 20px;
  padding: 3rem 3.5rem;
  box-shadow: 0 8px 40px rgba(74, 116, 168, 0.12);
  min-width: 340px;
  text-align: center;
}

.loading-logo {
  width: clamp(140px, 18vw, 200px);
  filter: none;
  opacity: 1;
}

/* ── Welcome text ────────────────────────────── */
.welcome-text {
  color: #4A74A8;
  font-size: 1.05rem;
  font-weight: 400;
  letter-spacing: 0.3px;
}

.user-name {
  color: #063c6d;
  font-weight: 700;
}

/* ── Progress bar ────────────────────────────── */
.progress-track {
  width: 100%;
  height: 3px;
  background: rgba(74, 116, 168, 0.12);
  border-radius: 99px;
  overflow: hidden;
}

.progress-bar {
  height: 100%;
  width: 40%;
  background: #4A74A8;
  border-radius: 99px;
  animation: slide 1.6s ease-in-out infinite;
}

@keyframes slide {
  0%   { transform: translateX(-100%); width: 40%; }
  50%  { width: 60%; }
  100% { transform: translateX(280%); width: 40%; }
}

/* ── Loading label ───────────────────────────── */
.loading-label {
  color: #4A74A8;
  font-size: 0.85rem;
  letter-spacing: 0.4px;
}
</style>

<script>
export default {
  name: 'MMP_LoadingScreen',
  props: ['user']
}
</script>
